import { Tween } from '../../../vendor_core/core/src/Tween';
import { State } from '../../../vendor_core/core/src/states/State';
import CoinModel from '../../model/CoinModel';


export default class CRCCoinState extends State {
    protected coinToShowDuration = 200;
    public enter(): void {
        super.enter();
        const coinNumbers = CoinModel.showNewCoins();
        const delay = this.coinToShowDuration / 1000;
        // const delay = (coinNumbers * this.coinToShowDuration) / 1000;
        Tween.delayedCall(delay, () => {
            this.exit()
        })
    }
}
